import { render, staticRenderFns } from "./RecruitingLogo.vue?vue&type=template&id=b806426e&"
import script from "./RecruitingLogo.vue?vue&type=script&lang=ts&"
export * from "./RecruitingLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports